import React, { useEffect, useState, useCallback } from 'react';
import PropTypes from "prop-types";
import withRouter from '../Components/Common/withRouter';
import Header from './Header';
import Sidebar from './Sidebar';
import Footer from './Footer';
import RightSidebar from '../Components/Common/RightSidebar';
import '@fortawesome/fontawesome-free/css/all.min.css';
import {
    changeLayout,
    changeSidebarTheme,
    changeLayoutMode,
    changeLayoutWidth,
    changeLayoutPosition,
    changeTopbarTheme,
    changeLeftsidebarSizeType,
    changeLeftsidebarViewType,
    changeSidebarImageType,
    changeSidebarVisibility,
    changePreLoader
} from "../slices/thunks";

import { useSelector, useDispatch } from "react-redux";
import { createSelector } from 'reselect';
import LoadingScreen from "../admin/components/util/LoadingScreen";

const Layout = (props) => {
    const [loadingLayout, setLoadingLayout] = useState(true);

    const dispatch = useDispatch();

    const selectLayoutState = (state) => state.Layout;
    const selectLayoutProperties = createSelector(
        selectLayoutState,
        layout => ({ ...layout })
    );

    const layoutSettings = useSelector(selectLayoutProperties);

    const onChangeLayout = useCallback((data) => {
        if (!data) return;

        dispatch(changeLayout(data.layoutType));
        dispatch(changeSidebarTheme(data.leftSidebarType));
        dispatch(changeLayoutMode(data.layoutModeType));
        dispatch(changeLayoutWidth(data.layoutWidthType));
        dispatch(changeLayoutPosition(data.layoutPositionType));
        dispatch(changeTopbarTheme(data.topbarThemeType));
        dispatch(changeLeftsidebarSizeType(data.leftsidbarSizeType));
        dispatch(changeLeftsidebarViewType(data.leftSidebarViewType));
        dispatch(changeSidebarImageType(data.leftSidebarImageType));
        dispatch(changePreLoader(data.preloader));
        dispatch(changeSidebarVisibility(data.sidebarVisibilitytype));
    }, [dispatch]);

    // Force dark theme with dark sidebar
    useEffect(() => {
        document.body.setAttribute("data-bs-theme", "dark");
        document.body.setAttribute("data-sidebar", "dark");
        document.body.setAttribute("data-layout-mode", "dark");
        document.body.setAttribute("data-topbar", "dark");
        // The Velzon theme stylesheets only apply layout rules (sidebar collapse,
        // horizontal-logo hiding, etc.) when these attributes live on <html>.
        // React doesn't set them automatically, so the sidebar wasn't collapsing
        // and the topbar logo was rendered alongside the sidebar one.
        document.documentElement.setAttribute("data-layout", "vertical");
        if (!document.documentElement.getAttribute("data-sidebar-size")) {
            document.documentElement.setAttribute("data-sidebar-size", "lg");
        }
        document.documentElement.setAttribute("data-layout-mode", "dark");
    }, []);

    useEffect(() => {
        const cache = localStorage.getItem('layout');
        if (cache) {
            try {
                const parsed = JSON.parse(cache);
                if (parsed && (parsed.layoutType === "horizontal" || parsed.layoutWidthType === "detached")) {
                    localStorage.removeItem('layout');
                } else {
                    onChangeLayout(parsed);
                }
            } catch (e) {
                localStorage.removeItem('layout');
            }
        }
        setLoadingLayout(false);
        document.title = "Oplena";
    }, [onChangeLayout]);


    const [headerClass, setHeaderClass] = useState("");

    useEffect(() => {
        const scrollNavigation = () => {
            const scrollup = document.documentElement.scrollTop;
            setHeaderClass(scrollup > 50 ? "topbar-shadow" : "");
        };

        window.addEventListener("scroll", scrollNavigation);
        return () => window.removeEventListener("scroll", scrollNavigation);
    }, []);

    useEffect(() => {
        const icon = document.querySelector(".hamburger-icon");
        if (!icon) return;

        if (layoutSettings.sidebarVisibilitytype === 'show' || layoutSettings.layoutType === "vertical" || layoutSettings.layoutType === "twocolumn") {
            icon.classList.remove('open');
        } else {
            icon.classList.add('open');
        }
    }, [layoutSettings.sidebarVisibilitytype, layoutSettings.layoutType]);

    return (
        <>
            {loadingLayout ? (
                <LoadingScreen />
            ) : (
                <React.Fragment>
                    <div id="layout-wrapper">
                        <Header
                            headerClass={headerClass}
                            layoutModeType={layoutSettings.layoutModeType}
                            onChangeLayoutMode={(mode) => dispatch(changeLayoutMode(mode))}
                        />
                        <Sidebar layoutType={layoutSettings.layoutType} />
                        <div className="main-content">
                            {props.children}
                            <Footer />
                        </div>
                    </div>
                    <RightSidebar />
                </React.Fragment>
            )}
        </>
    );
};

Layout.propTypes = {
    children: PropTypes.object,
};

export default withRouter(Layout);
